import { render, staticRenderFns } from "./ActivationPopup.vue?vue&type=template&id=a16fcd24&scoped=true"
import script from "./ActivationPopup.vue?vue&type=script&lang=js"
export * from "./ActivationPopup.vue?vue&type=script&lang=js"
import style0 from "./ActivationPopup.vue?vue&type=style&index=0&id=a16fcd24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16fcd24",
  null
  
)

export default component.exports